import { makeRequest } from 'services/utils';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';

const { BulkEmails, BulkEmailSignature } = Endpoints;

const { success: successCopies, errors: errorCopies } = strings.bulkEmails;

/**
 * @param {Bulk} bulk
 * @returns {Promise<OperationResult>}
 */
export const sendBulkEmail = async bulk =>
  makeRequest({
    url: BulkEmails,
    data: bulk,
    method: 'post',
    alertConfig: {
      success: bulk.is_draft ? successCopies.sendBulkDraft : successCopies.sendBulkEmail,
      error: bulk.is_draft ? errorCopies.sendBulkDraft : errorCopies.sendBulkEmail
    }
  });

/**
 * @returns {Promise<OperationResult>}
 */
export const getBulkEmailSignature = async () =>
  makeRequest({
    url: BulkEmailSignature,
    method: 'get',
    alertConfig: {
      error: {
        title: errorCopies.gettingEmailSignature
      }
    }
  });
